module.exports = __webpack_public_path__ + "static/media/comet.3e24abcc.svg";